import * as z from "zod";

export const uploadFile = {
  name: "uploadFile" as const,
  input: z.object({
    fileName: z.string(),
    fileContent: z.string(), // base64 encoded file content
    mimeType: z.string(),
  }),
  output: z.object({
    url: z.string(),
    description: z.string(),
    mimeType: z.string(),
  }),
};
